'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _ = require('./');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var savedSearchItemSortOrders = (0, _extends3.default)({}, _.itemSortOrders, {
    RESULT_RECENT_FIRST: 'RESULT_RECENT_FIRST',
    RESULT_OLDEST_FIRST: 'RESULT_OLDEST_FIRST'
}); /*eslint-disable sort-keys */
exports.default = savedSearchItemSortOrders;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/enums/savedSearchItemSortOrders.js
// module id = bDm4
// module chunks = 46